import Table from '@/components/table/components/Table.tsx';
import tourParticipantsApi from '@/features/dashboard/tours/api/tourParticipantsApi.ts';
import {
  tourParticipantsRoute,
  tourRoute,
} from '@/features/dashboard/tours/routes/tourRoute.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import { tourParticipantsApiQueryKeys } from '@/features/dashboard/tours/api/tourParticipantsApi.queryKeys.ts';
import { RowContextMenuItemParams } from '@/components/table/components/RowContextMenu.tsx';
import { RowWithId } from '@/components/table/types/RowWithId.ts';
import { useNavigate } from '@tanstack/react-router';

const TourParticipantsTable = () => {
  const { tourId } = tourRoute.useParams();
  const search = tourParticipantsRoute.useSearch();
  const navigate = useNavigate();

  const rowContextMenuItems: RowContextMenuItemParams<RowWithId>[] = [
    {
      label: 'Szczegóły',
      action: (row) =>
        navigate({
          to: '/app/participants/$participantId/info',
          params: { participantId: row.id },
        }),
    },
  ];

  return (
    <Table
      listSearch={search}
      queryKey={tourParticipantsApiQueryKeys.tourParticipants(tourId)}
      fetchData={(pr, fc: FilterCriteriaDto) =>
        tourParticipantsApi.getParticipants(tourId, pr, fc)
      }
      fetchTableDef={() => tourParticipantsApi.getTableDef(tourId)}
      rowContextMenuItems={rowContextMenuItems}
      // Enables row selection + the floating bar with "export selected".
      // Add context actions here once an endpoint exists, e.g.:
      // bulkActions={[createDeleteSelectedAction({ onDelete: (rows) => ... })]}
      bulkActions={[]}
      title="Uczestnicy"
    />
  );
};

export default TourParticipantsTable;
